import {css} from 'lit';
export const styles = css`:host {
  --align-items: center;
  --icon-size: 30px;
  --link-text-hover: var(--body-text);
  --link-text-active: var(--body-text);
  --link-hover-background: var(--gray-300);
  --link-active-background: var(--gray-400);

  display: flex;
  align-items: var(--align-items);
  margin-bottom: 8px;
  padding-left: 8px;
  padding-right: 8px;
}

slot[name='left']::slotted(*) {
  margin-right: 12px;
}

slot[name='right']::slotted(*) {
  margin-left: 12px;
}

ef-icon {
  font-size: var(--icon-size);
  margin-right: 12px;
}

.list-header-content {
  flex: 1 1 auto;
}

.list-header-content .list-header-title {
    display: flex;
    margin: 0;
    font-size: 14px;
    font-weight: 400;
    text-transform: uppercase;
  }

.list-header-content .list-header-info {
    font-size: 0.8em;
    color: var(--dark-secondary);
  }

a {
  --link-text: var(--body-text);

  margin-left: -4px;
  margin-bottom: -2px;
  padding: 2px 4px;
  color: var(--body-text);
  border-radius: 16px;
}

@media (hover: hover) {
    a:hover {
      background-color: var(--link-hover-background);
    }
  }

a:active {
    background-color: var(--link-active-background);
  }
`;
export default styles;
